import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AssetVersionPipe} from '../../../../pipes/asset-version.pipe';
import { DataTestIds } from '../../../../../../e2e/types';
const EACH_STEP_DELAY = 10000;

@Component({
  selector: 'app-progress-bar',
  imports: [CommonModule, AssetVersionPipe],
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss'
})
export class ProgressBarComponent implements OnInit, OnDestroy {
  @Input() totalSteps = 5;
  @Input() currentStep = 1;
  @Input() isCompleted = false;
  @Input() isError = false;
  @Input() stepLabels = [
    'Gathering recent data…',
    'Identifying key metrics…',
    'Generating insights…',
    'Preparing your analysis…',
    'Organizing results for review...',
    'Analysis completed'
  ];
  @Input() startTimestamp?: number;

  private intervalId: ReturnType<typeof setInterval> | null = null;
  protected readonly dataTestIds = DataTestIds;

  ngOnInit(): void {
    if (this.startTimestamp) {
      const elapsed = Date.now() - this.startTimestamp;
      this.currentStep = Math.min(Math.floor(elapsed / EACH_STEP_DELAY) + 1, this.totalSteps);
    }

    this.intervalId = setInterval(() => {
      if (this.currentStep < this.totalSteps) {
        this.currentStep++;
      }
    }, EACH_STEP_DELAY);
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}


